import { useActorRef } from '@xstate/react';

import { loyaltyOffersModalMachine } from '../../machine';

// ─────────────────────────────────────────────────────────────────────────────

export const useInitLoyaltyOffersModalMachine = () => {
  return useActorRef(loyaltyOffersModalMachine);
};
